import * as React from 'react';
import { CinchDialog } from '@cinch/ui';
import Button from '@mui/material/Button';
import { FileViewer2 } from './file-viewer.component-mui';
import CssBaseline from '@mui/material/CssBaseline';
export function ModalFileViewer2(props) {
  const [selectedFile, setSelectedFile] = React.useState(null);
  const selectFile = file => {
    if (file.isFolder) {
      setSelectedFile(null);
    } else {
      setSelectedFile(file);
    }
  };
  return <div className="mui-wrapper">
      <CssBaseline />
      <CinchDialog open={props.open} onClose={() => props.onClose(null)} title="Attach File" customWidth={{
      xs: 'calc(100vw - 24px)',
      md: '70vw'
    }} customHeight="auto" bodyData={<FileViewer2 onSelect={selectFile} hideCSVs />} actions={<div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end'
    }}>
            <Button onClick={() => props.onClose()} sx={{
        borderRadius: '20px',
        color: '#53A6D6',
        width: '125px',
        borderStyle: 'solid',
        borderColor: '#53A6D6',
        borderWidth: '1px'
      }}>
              Cancel
            </Button>
            <Button disabled={!selectedFile} onClick={() => {
        props.onSubmit(selectedFile);
        props.onClose();
      }} variant="contained" sx={{
        borderRadius: '20px',
        width: '125px'
      }}>
              Attach
            </Button>
          </div>} />
    </div>;
}